module.exports = __webpack_public_path__ + "static/img/042统战H5页面.8f67a89.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/042统战H5页面.jpg
// module id = wwnR
// module chunks = 0